<template>
    <div class="ah-page bank-transfer-add-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">新增存款帳戶互轉</h1>
                        <h1 v-else>編輯存款帳戶互轉</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="150px" v-loading="isLoading">
                <el-row :gutter="20">
                    <el-col :sm="24">
                        <el-alert v-if="form.sno" :closable="false" type="warning" style="margin-bottom: 15px" center>提醒您，已送出的金額與日期不可更改，如需修正請刪除此單再重做。</el-alert>
                    </el-col>
                    <el-col :sm="12">
                        <div class="ah-panel">
                            <div class="panel-body">
                                <div class="sub-title">轉出</div>
                                <el-form-item prop="transferDate" label="轉出日期">
                                    <el-date-picker v-model="form.transferDate" :disabled="!!form.sno" value-format="timestamp" type="date" placeholder="選擇日期"> </el-date-picker>
                                </el-form-item>
                                <el-form-item prop="sourceBankSno" label="轉出帳戶">
                                    <ah-el-select-bank-account
                                        v-model="form.sourceBankSno"
                                        :disabled="!!form.sno"
                                        :disabled-option="disabledOutBank"
                                        document-type='transfer'
                                        @change="onOutBankChange"
                                    ></ah-el-select-bank-account>
                                </el-form-item>
                                <el-form-item v-if="form.sourceCny !== 'TWD'" prop="sourceRate" label="兌換台幣匯率">
                                    <div style="display: inline-flex; gap: 10px;">
                                        <money-input v-model="form.sourceRate" :disabled="!!form.sno" :precision="4" style="width: 150px; flex-shrink: 0;" @change="handleOutCnyRatChange" />
                                    </div>
                                </el-form-item>
                                <div style="display: flex; flex-direction: column; gap: 10px;">
                                    <div style="display: flex; gap: 10px;">
                                        <el-form-item prop="sourceAmt" label="轉出金額" style="margin-right: 5px">
                                            <money-input
                                                v-model="form.sourceAmt"
                                                :suffix="form.sourceCny"
                                                :precision="form.sourceCny == 'TWD' ? 0 : 4"
                                                :disabled="!!form.sno"
                                                style="max-width: 250px;"
                                                @change="handleOutAmtChange"
                                            />
                                        </el-form-item>
                                        <el-form-item label="約當台幣" v-if="form.sourceCny !== 'TWD'">
                                            <money-input
                                                :value="sourceTwd"
                                                suffix="TWD"
                                                style="max-width: 250px;"
                                                disabled
                                            />
                                        </el-form-item>
                                    </div>
                                    <!-- <el-alert
                                        v-if="form.sourceCny !== 'TWD' && Math.abs(sourceTwd - targetTwd) > 5"
                                        type="warning"
                                        show-icon
                                        :closable="false"
                                        title="請注意匯率換算是否正確！"
                                    ></el-alert> -->
                                </div>
                                <el-form-item prop="sourceFee" label="匯費">
                                    <money-input
                                        v-model="form.sourceFee"
                                        :disabled="!!form.sno"
                                        :suffix="form.sourceCny"
                                        :precision="form.sourceCny == 'TWD' ? 0 : 4"
                                        style="width: 150px; margin-right: 5px"
                                    />
                                </el-form-item>
                                <el-form-item prop="source_ITEM_SNO" label="支出項目">
                                    <div class="block">
                                        <ahSelectVariableStateItem
                                            v-if="!isLoading"
                                            v-model="form.source_ITEM_SNO"
                                            :enableType="['cOutElse']"
                                            :hideTip="true"
                                            :keywords="['台外幣', '互轉', '互換']"
                                            @onLoaded="onVariableStateSelectorLoaded('source')"
                                        />
                                    </div>
                                </el-form-item>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="12">
                        <div class="ah-panel">
                            <div class="panel-body">
                                <div class="sub-title">轉入</div>
                                <el-form-item prop="transferDate" label="轉入日期">
                                    <el-date-picker v-model="form.transferDate" disabled value-format="timestamp" type="date" placeholder="選擇日期"> </el-date-picker>
                                </el-form-item>
                                <el-form-item prop="targetBankSno" label="轉入帳戶">
                                    <ah-el-select-bank-account
                                        v-model="form.targetBankSno"
                                        :disabled="!!form.sno"
                                        :disabled-option="disabledInBank"
                                        document-type='transfer'
                                        @change="onInBankChange"
                                    ></ah-el-select-bank-account>
                                </el-form-item>
                                <el-form-item v-if="form.targetCny !== 'TWD'" prop="targetRate" label="兌換台幣匯率">
                                    <div style="display: inline-flex; gap: 10px;">
                                        <money-input v-model="form.targetRate" :disabled="!!form.sno" :precision="4" style="width: 150px; flex-shrink: 0;" @change="handleInCnyRatChange" />
                                    </div>
                                </el-form-item>
                                <div style="display: flex; flex-direction: column; gap: 10px;">
                                    <div style="display: flex; gap: 10px;">
                                        <el-form-item prop="targetAmt" label="轉入金額">
                                            <money-input
                                                v-model="form.targetAmt"
                                                :suffix="form.targetCny"
                                                :precision="form.targetCny == 'TWD' ? 0 : 4"
                                                :disabled="!!form.sno"
                                                style="width: 200px;"
                                            />
                                        </el-form-item>
                                        <el-form-item label="約當台幣" v-if="form.targetCny !== 'TWD'">
                                            <money-input
                                                :value="targetTwd"
                                                suffix="TWD"
                                                style="max-width: 250px;"
                                                disabled
                                            />
                                        </el-form-item>
                                    </div>
                                    <!-- <el-alert
                                        v-if="form.sourceCny !== 'TWD' && Math.abs(sourceTwd - targetTwd) > 5"
                                        type="warning"
                                        show-icon
                                        :closable="false"
                                        title="請注意匯率換算是否正確！"
                                    ></el-alert> -->
                                </div>
                                <el-form-item prop="targetFee" label="匯費">
                                    <money-input
                                        v-model="form.targetFee"
                                        :disabled="!!form.sno"
                                        :suffix="form.targetCny"
                                        :precision="form.targetCny == 'TWD' ? 0 : 4"
                                        style="width: 150px; margin-right: 5px"
                                    />
                                </el-form-item>
                                <el-form-item prop="target_ITEM_SNO" label="收入項目">
                                    <div class="block">
                                        <ahSelectVariableStateItem
                                            v-if="!isLoading"
                                            v-model="form.target_ITEM_SNO"
                                            :enableType="['cInElse']"
                                            :hideTip="true"
                                            :keywords="['台外幣', '互轉', '互換']"
                                            @onLoaded="onVariableStateSelectorLoaded('target')"
                                        />
                                    </div>
                                </el-form-item>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :sm="24">
                        <div class="ah-panel">
                            <div class="panel-body">
                                <el-form-item prop="note" label="備註">
                                    <el-input type="textarea" v-model="form.note" :autosize="{ minRows: 4, maxRows: 15 }" maxlength="200" show-word-limit class="editable-textarea"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :sm="24">
                        <div class="ah-panel">
                            <div class="panel-body">
                                <BankTransferFilesView ref="BankTransferFilesView" :form="form" create-mode @change="onChangeFiles" @reload="fetchDetail" />
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <center>
                <el-button v-if="form.sno && !isQR()" :loading="isSubmitting" type="danger" @click="onDelete">刪除</el-button>
                <el-button :loading="isSubmitting" @click="onBackToList">取消</el-button>
                <el-button v-if="!isQR()" type="primary" class="primary-action" @click="onSubmit" :loading="isSubmitting">送出</el-button>
            </center>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import BankTransferFilesView from '@/components/dashboard/Finance/VariableStatement/BankTransferFilesView.vue';

export default {
    components: {
        ahElSelectBankAccount,
        ahSelectVariableStateItem,
        BankTransferFilesView,
    },
    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            statementType: '',
            disabledOutBank: null,
            disabledInBank: null,
            form: {
                sno: null,
                type: 0,
                iteM_type: 0,

                sourceBankSno: null,
                transferDate: new Date().getTime(),
                source_ITEM_SNO: null,
                sourceCny: 'TWD',
                sourceAmt: null,
                sourceRate: 1,
                sourceFee: 0,

                targetBankSno: null,
                target_ITEM_SNO: null,
                targetCny: 'TWD',
                targetAmt: null,
                targetRate: 1,
                targetFee: 0,

                note: null,

                attachments: [],
            },
            rules: {
                sourceBankSno: [
                    {
                        required: true,
                        message: '請選擇轉出帳戶',
                        trigger: 'change',
                    },
                ],
                targetBankSno: [
                    {
                        required: true,
                        message: '請選擇轉入帳戶',
                        trigger: 'change',
                    },
                ],
                transferDate: [
                    {
                        required: true,
                        message: '請選擇轉出日期',
                        trigger: 'change',
                    },
                ],
                source_ITEM_SNO: [
                    {
                        required: true,
                        message: '請選擇項目',
                        trigger: 'change',
                    },
                ],
                target_ITEM_SNO: [
                    {
                        required: true,
                        message: '請選擇項目',
                        trigger: 'change',
                    },
                ],
                sourceAmt: [
                    {
                        required: true,
                        message: '請輸入轉出金額',
                        trigger: 'blur',
                    },
                ],
                targetAmt: [
                    {
                        required: true,
                        message: '請輸入轉入金額',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    created() {
        this.form.sno = Number(this.$route.params.sno);
        if (this.form.sno) this.fetchDetail();
    },
    computed: {
        sourceTwd() {
            return Math.round(this.form.sourceAmt * this.form.sourceRate);
        },
        targetTwd() {
            return Math.round(this.form.targetAmt * this.form.targetRate);
        },
    },
    methods: {
        async fetchDetail() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: '/AccountTransferRecord/GetRecordDetail',
                    method: 'GET',
                    params: { sno: this.form.sno },
                });

                this.form = resp.data.detail;
            } finally {
                this.isLoading = false;
            }
        },
        // 變更銀行帳戶：同時變更對應的幣別
        onOutBankChange(bank) {
            this.disabledInBank = bank;
            this.form.sourceCny = bank.cny;
            this.form.sourceRate = this.getCnyRat(bank.cny);
        },

        onInBankChange(bank) {
            this.disabledOutBank = bank;
            this.form.targetCny = bank.cny;
            this.form.targetRate = this.getCnyRat(bank.cny);
            this.updateInAmt();
        },

        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },

        onBackToList() {
            this.$router.push({ name: 'variable-statement-bank-transfer', query: { startDate: this.$route.query.startDate, endDate: this.$route.query.endDate } });
        },

        async onDelete() {
            try {
                await this.$confirm('確定要刪除此存款帳戶互轉紀錄？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isSubmitting = true;
                await this.$api({
                    url: 'AccountTransferRecord/DeleteRecord',
                    method: 'POST',
                    data: { sno: this.form.sno },
                });

                this.$message({
                    showClose: true,
                    message: '存款帳戶互轉紀錄已刪除',
                    type: 'success',
                });
                this.onBackToList();
            } finally {
                this.isSubmitting = false;
            }
        },

        onSubmit() {
            // 表單驗證
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.isSubmitting = true;

                        const url = this.form.sno ? 'AccountTransferRecord/UpdateRecord' : 'AccountTransferRecord/AddRecord';
                        const ACTION_TXT = this.form.sno ? '儲存' : '新增';

                        await this.$api({
                            url,
                            method: 'POST',
                            data: this.form,
                        });

                        this.$message({
                            showClose: true,
                            message: `存款帳戶互轉紀錄已${ACTION_TXT}`,
                            type: 'success',
                        });
                        this.onBackToList();
                    } finally {
                        this.isSubmitting = false;
                    }
                } else {
                    this.scrollViewToError();
                }
            });
        },

        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },

        onChangeFiles(value) {
            this.form.attachments = _.map(value, (o) => ({
                nam: o.nam,
                note: o.note,
                attachmentUrl: o.filE_ATT,
                upD_NAM: o.updateUser,
                upD_DAT: o.updateTime,
            }));
        },

        handleOutAmtChange() {
            this.updateInAmt();
        },

        handleOutCnyRatChange() {
            this.updateInAmt();
        },

        handleInCnyRatChange() {
            this.updateInAmt();
        },

        updateInAmt() {
            const TRANSFORM = (this.form.sourceAmt * this.form.sourceRate) / this.form.targetRate;
            this.form.targetAmt = this.form.targetCny === 'TWD' ? Math.round(TRANSFORM) : Math.round(TRANSFORM * 10000) / 10000;
        },

        onVariableStateSelectorLoaded(field) {
            const sno = this.form[`${field}_ITEM_SNO`];
            this.form[`${field}_ITEM_SNO`] = null;
            setTimeout(() => {
                this.form[`${field}_ITEM_SNO`] = sno;
            }, 1);
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.bank-transfer-add-page {
    .sub-title {
        color: $main-color;
        font-size: 15pt;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .editable-textarea textarea {
        border-bottom-right-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
    }
    .none-editable-textarea textarea {
        border-top-right-radius: 0 !important;
        border-top-left-radius: 0 !important;
        border-top: 0 !important;
    }

    .money-info-block {
        display: flex;
        :first-child {
            margin-right: 50px;
        }
    }
}
</style>
